<template>
<div>

    <BaseInput :label="schema.label">
        <template v-if="isUploading">
        <div v-for="upload in uploading" class="file-row" style="width:100%" :key="upload.name">
                <div style="flex-basis:40px">
                    <v-icon color="grey">{{fileIcon(upload.type)}}</v-icon>
                </div>
                <div style="color:#888;flex-grow:1;text-align:left" class="no-wrap">{{upload.name.replace(/-.{6}\./, '.')}}</div>
                <div style="flex-basis:100px;padding-top:18px;"><v-progress-linear v-model="upload.progress" /></div>         
        </div>
        </template>

        <div v-for="(file, idx) in value" :key="file.name">
           
            <DocumentView :url="value[idx].url" :type="value[0].type">
                <div  class="file-row" :class="{single:!schema.multiple}">
                    <div style="flex-basis:40px">
                        <v-icon color="grey">{{fileIcon(file.type)}}</v-icon>
                    </div>
                    <div style="color:#888;flex-grow:1;text-align:left" class="no-wrap">{{file.name.replace(/-.{6}\./, '.')}}</div>
                    <div><ConfirmIcon small corner @click="deleteFile(file)" style="top:4px;"/></div>
                </div>
            </DocumentView>
         
        </div>    

        <div v-if="uploaderVisible" class="display-flex full-width xxxpt-1" >
            <div class="file-upload" :class="{'has-files': value && value.length}" style="flex-grow:1">
                <input ref="url" placeholder="https://www.link.com/file  (ESC to Cancel)" v-if="linking" type="text" class="quick-input" style="margin: -3px 0 -4px 0" v-model="url" @keydown.esc="hideLinking" />
                <UploadWrapper v-else :multiple="schema.multiple"  @click @select="uploadFiles">
                    <v-icon color="grey lighten-1" class="mr-2">mdi-upload</v-icon>Drag or Click to Upload
                </UploadWrapper>
            </div>            
            <div @click="link" class="file-upload" style="flex-basis:100px;border-left:solid 1px #ccc;position:relative">
                <div v-if="!linking" class="link-or elevation-1">OR</div>
                Link
            </div>
        </div>

    </BaseInput>

</div>
</template>

<script>
import UploadWrapper from '@/ui-elements/UploadWrapper'
import ConfirmIcon from '@/ui-elements/ConfirmIcon'
import FileHelpers from '../../helpers/FileHelpers'
import DocumentView from '../../ui-elements/DocumentView'
import BaseInput from '@/forms/inputs/BaseInput'
import Utilities from '../../helpers/Utilities'

export default {
    data() {
        return {
            url: null,
            linking: false,
            uploading: []
        }
    },

    components: {
        ConfirmIcon,
        UploadWrapper,
        DocumentView,
        BaseInput,
    },
    
    props: {
        value: Array,
        schema: Object,
    },

    computed: {
        isUploading() {
            return this.uploading.length > 0
        },
        uploaderVisible() {
            if(this.isUploading)
                return false
            if(this.schema.multiple)
                return true
            return !this.value || !this.value.length  
        }
    },

    methods: {
     

        uploadFiles(files) {
            console.log('upload....')
            FileHelpers.storeFiles(files, this.schema.path, this.uploadStart, this.uploadStatus, this.uploadFinish )
        },

        uploadStart(files) {
            console.log('uploadStart', files)
            this.uploading = files
        },

        uploadStatus(files) {
            console.log(files)
        },

        uploadFinish(files) {
            console.log('Finished uploading', files)
            this.addFiles(this.uploading)
            this.uploading = []
        },

        addFiles(arr) {
            const newVal = [...(this.value || []), ...arr]
            this.$emit('input', newVal)
            this.$emit('change', newVal)
        },

        deleteFile(file) {
            const files = [...this.value]
            const idx = files.findIndex(o => o == file)
            files.splice(idx,1)
            this.$emit('input', files)
            this.$emit('change', files)
        },
        fileIcon(type) {
            if(!type)
                return 'mdi-file-document'
            if(type=='application/pdf') {
                return 'mdi-file-pdf-box'
            } else if(type.startsWith('image'))
                return 'image'
            else
                return 'mdi-file-document'
        },
        link() {
            if(this.linking) {
                if(this.url)
                    this.addFiles([{'name': this.url, 'url': this.url}])
                this.hideLinking()

            } else {
                this.linking = true
                Utilities.focus(this, 'url')
            }
        },

        hideLinking() {
            this.url = null
            this.linking = false
        }

    },

    created() {

    }
}
</script>

<style scoped>  
.file-upload {
    /* position:relative; */
    /* border-radius:5px; */
    padding:9px 9px 9px 7px;
    text-align:center;
    /* border: dashed 1px rgba(0,0,0,0.4); */
    color:#999;
    user-select: none;
    cursor: pointer;
    font-size: 14px;
}
.file-upload:hover {
    border-color: rgba(0,0,0,0.3);
    color:#aaa;
    background-color: rgba(0,0,0,0.05);
}

.file-row {
    display:flex;
    gap:10px;
    border-bottom: solid 1px #ccc;
    user-select:none;
}
.file-row.single {
    border-bottom: none;
}
.file-row > div {
    padding:8px 16px;
}


.uploading-file {
    position: relative;
    display:inline-block;
    height:100px;
    width:100px;
    color:rgba(0,0,0,0.5);
    border: solid 2px rgba(0,0,0,0.3);
    border-radius: 5px;
    padding:10px;
    overflow:hidden;
    font-size:12px;
    /* margin:5px; */
}

.file-name-bar {
    position:absolute;
    bottom:0;
    left:0;
    right:0;
    height:25px;
    overflow: hidden;
    text-overflow: ellipsis;
    background-color: rgba(0,0,0,0.3);
    color:white;
    font-size:14px;
    padding:3px;
    white-space: nowrap;
}

.close-icon {
    position: absolute;
    top:0px;
    right:0px;
}
.close-icon:hover {
    background-color: rgb(243, 3, 3, .3);
}

file-progress {
    position:absolute;
    bottom: -10px;
    left:0;
    right:0;
}
.inline-label {
    position:absolute;
    top: -5px;
    font-size:12px;
    left: 5px;
    color: #999;
    background-color:white
}
.link-or{
    position:absolute;
    height:24px;
    width:24px;
    top:9px;
    left: -12px;
    padding:3px 3px;
    border-radius: 50%;
    border: solid 1px #ddd;
    background-color:white;
    font-size:10px;
    font-weight:500;
    /* color:white;
    background-color:#ccc; */
}


   
</style>




// WEBPACK FOOTER //
// FileControl.vue?e0facf04